export default __webpack_public_path__ + "static/profile-92501ec7a4354d93edf6a9dfcf2e442f.jpg";